import { render, staticRenderFns } from "./ModalCreditProducts.vue?vue&type=template&id=4186a724&scoped=true&"
import script from "./ModalCreditProducts.vue?vue&type=script&lang=js&"
export * from "./ModalCreditProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186a724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4186a724')) {
      api.createRecord('4186a724', component.options)
    } else {
      api.reload('4186a724', component.options)
    }
    module.hot.accept("./ModalCreditProducts.vue?vue&type=template&id=4186a724&scoped=true&", function () {
      api.rerender('4186a724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/tabs/components/ModalCreditProducts.vue"
export default component.exports